import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=2b96642e&scoped=true&"
import script from "./EventList.vue?vue&type=script&lang=js&"
export * from "./EventList.vue?vue&type=script&lang=js&"
import style0 from "./EventList.vue?vue&type=style&index=0&id=2b96642e&prod&lang=scss&scoped=true&"
import style1 from "./EventList.vue?vue&type=style&index=1&id=2b96642e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b96642e",
  null
  
)

export default component.exports